import { EuiFlexGroup } from "@elastic/eui";
import React from "react";

import ProductImage from "./ProductImage";

interface PriceTableHeaderNewProps {
    title: string;
    cols: string[];
    isMultiScreen: boolean;
    topHeader?: boolean;
    image?: string;
    enableImageForCategory?: boolean;
    shopId?: string; //TODO: REMOVE
}

const MMMEShopIds = [
    "a08a13e2-a31b-4b6d-b2b4-0491cb3d2227",
    "19149768-691c-40d8-a08e-fe900fd23bc0",
    "bbc0cfa7-e230-4338-817a-55190debdac0",
    "ddd70853-5e9d-45ff-82b3-24c9d81d4e32",
];

const renderCol = (col: string, index: number, shopId?: string) => {
    const amount = col.match(/^\d+(?:[.,]\d+)?/)?.[0] ?? "";
    let unit = col.replace(amount || "", "").trim();

    switch (unit) {
        case "gram":
        case "g":
            unit = "gram";
            break;
        case "j":
            unit = "joint";
            break;
        case "st":
            unit = "stuks";
            break;
    }

    const isMMMShop = MMMEShopIds.includes(shopId || "");

    return (
        <p key={index} className="priceHeader">
            {isMMMShop ? (
                <>
                    <span className="amount">{amount.replace(".", ",")}</span>
                    <span className="unit">{unit}</span>
                </>
            ) : (
                <>{col.replace(" gram", "g").replace(".", ",")}</>
            )}
        </p>
    );
};

export const PriceTableHeaderNew: React.FC<PriceTableHeaderNewProps> = ({
    title,
    cols,
    topHeader,
    image,
    isMultiScreen,
    enableImageForCategory,
    shopId, //TODO: REMOVE -> (https://github.com/acidjunk/pricelist-shop/issues/341)
}) => {
    return (
        <div>
            {shopId === "470f3f5a-e7b9-43a5-bbfd-2ffce8c161e4" ? ( //TODO: Fixes misalignent of rows on 4k and 1080p
                <div style={{ display: "flex", marginBottom: "-1vw" }}>
                    {image && isMultiScreen && enableImageForCategory ? (
                        <ProductImage className="categoryImage" imageKey={image} />
                    ) : (
                        <h2 style={{ paddingBottom: "0.5vw" }} className={topHeader ? "title" : "titleNotAtTop"}>
                            {title}
                        </h2>
                    )}
                </div>
            ) : (
                <EuiFlexGroup alignItems="center" gutterSize="s">
                    {image && isMultiScreen && enableImageForCategory ? (
                        <ProductImage className="categoryImage" imageKey={image} />
                    ) : (
                        <h2 className={topHeader ? "title" : "titleNotAtTop"}>{title}</h2>
                    )}
                </EuiFlexGroup>
            )}

            <div className="info">
                {cols
                    .slice(0)
                    .reverse()
                    .map((col, index) => renderCol(col, index, shopId))}
            </div>
        </div>
    );
};
